<form [formGroup]="caixaTexto">
    <mat-form-field style="width: 50vw;" >
        <mat-label>Descrição da Solução</mat-label>
        <textarea class="caixaTexto" type="text" matInput formControlName="texto" matAutosize="true"></textarea>
    </mat-form-field>
</form>

<div *ngIf="arquivo == null && necessarioAnexo" class="mb-2">
    <a style="cursor: pointer; font-weight: bolder !important;" (click)="AbrirCaixaArquivos()">
      <svg width="1.3em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle"  fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"/>
        <path fill-rule="evenodd" d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"/>
        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
      </svg> Adicionar contrato
    </a>
</div> 
<input type="file" id="CaixaArquivos" accept=".pdf, .xlsx, .xls" lang="pt" multiple (change)="ArquivosSelecionados($event.target.files)" hidden>

<div *ngIf="arquivo" style="display: flex; justify-content: space-between; background-color: #f5f5f5; height: 35px; margin-bottom: 10px;">
    <p style="font-weight: bolder; color: #2f79e9; font-size: 14px; margin-top: 8px; margin-left: 5px"> {{arquivo.Descricao}} </p>
    <mat-icon style="cursor: pointer; font-size: 17px; margin-top: 8px;" (click)="ExcluirArquivo()">close</mat-icon>
</div>



<div class="row justify-content-end">
    <button style="margin-right: 5px !important;" mat-raised-button color="warn" (click)="Resposta(false)">Cancelar</button>
    <button [disabled]="caixaTexto.status == 'INVALID' || VerificaAnexo()" mat-raised-button color="primary" (click)="Resposta(true)">Gravar</button>
</div>
